//Live Constants
// export const API_BASE_URL = "https://orthopub.molecularconnections.com/orthopub_service";
// export const googleAnalyticsTrackingId = 'G-3J8XHKWS70';  

//Test Constants
export const API_BASE_URL = "https://prod.editorease.molecularconnections.com";
export const AUTHOREASE_PDF_PARSER_SERVICE = "https://authorease.ai/authorease_pdf_parser_service"
// export const googleAnalyticsTrackingId = 'G-5HKPZVYS0N';
export const googleAnalyticsTrackingId = 'G-4FPKYZLE9Z' //Personal GA 

export const authContentType = "application/x-www-form-urlencoded";

// Application settings
export const maintenanceMode = false; // Set to true to enable maintenance mode (all routes will redirect to maintenance page)